import React, { useEffect, useState } from 'react';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';
import xlsx from '../images/xlsx.png';
import pdf from '../images/pdf.png';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { utils, writeFile } from 'xlsx';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
	getVisit,
	getPatientList,
	postVisitDatalist,
} from '../../../../app/services/api/apiManager';
import dayjs from 'dayjs';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PatientReport from '../PatientReport';
import ReportResultsGrid from '../ReportResultsGrid';
import {
	filterSectionStyle,
	headerSection,
	reportExcelButtonSx,
	reportPdfButtonSx,
	reportResetButtonSx,
	textStyling,
	headerStyling,
} from './GeneralStyles';
import {
	Box,
	Button,
	Checkbox,
	Divider,
	Grid,
	Paper,
	Typography,
} from '@mui/material';

const reportFilterLabelSx = {
	mb: 0.5,
	fontFamily: 'Poppins',
	fontSize: '12px',
	fontWeight: 600,
	color: '#172d58',
};

const reportFilterFieldSx = {
	width: '100%',
	'& .MuiInputBase-root': {
		height: 40,
		borderRadius: '6px',
		backgroundColor: '#fff',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#122b55',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: '#d6e2f2',
	},
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#b9cbe3',
	},
	'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#2E68BA',
		borderWidth: '1px',
	},
	'& .MuiInputBase-input': {
		padding: '9px 12px',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#122b55',
		boxSizing: 'border-box',
	},
	'& .MuiSelect-select': {
		display: 'flex',
		alignItems: 'center',
	},
};

const reportMenuProps = {
	PaperProps: {
		sx: {
			maxHeight: 280,
			borderRadius: '8px',
			boxShadow: '0 8px 24px rgba(16, 24, 40, 0.14)',
			'& .MuiMenuItem-root': {
				minHeight: 34,
				py: 0.75,
				fontFamily: 'Poppins',
				fontSize: '13px',
				color: '#122b55',
			},
		},
	},
};

const LengthStayHistory = () => {
	// Get Data with Practice ID
	const practiceID = localStorage.getItem('practice_id');
	// Navigate to Page State
	const [currentPage, setCurrentPage] = useState(true);
	// Loader State
	const [isLoading, setIsLoading] = useState(true);
	const [gridLoading, setGridLoading] = useState(false);
	// Api's Data State
	const [allVisits, setAllVisits] = useState([]); // Visit Api Data
	const [allPatientsData, setAllPatientsData] = useState([]); // Patient Api Data
	const [pdfUrl, setPdfUrl] = useState('');

	// Handle Patient Name ( Field ) State
	const [selectPatient, setSelectPatient] = useState([]);

	// Filter Data with TextShows Headlines State
	const [filterationData, setFilterationData] = useState([]);
	// Handle Date Value States
	const [dateValue, setDateValue] = useState({
		admitDate: dayjs().startOf('month'), // Get the start of the current month
		dischargeDate: dayjs(),
	});

	// Formate date
	const formatFromDate = dayjs(dateValue.admitDate).format('YYYY-MM-DD');
	const formatToDate = dayjs(dateValue.dischargeDate).format('YYYY-MM-DD');

	// Target Date Value Function
	const handleDateValue = (name, date) => {
		setDateValue({
			...dateValue,
			[name]: date,
		});
		getVisitListData(filterData);
	};

	// Handle Reset Value
	const resetValues = () => {
		setDateValue({
			admitDate: '',
			dischargeDate: '',
		}),
			setSelectPatient([]);
		setFilterationData([]);
		getVisitListData({ practice_id: practiceID });
	};

	// Function For Getting API Visits Data
	// const getVisits = async () => {
	// 	try {
	// 		// const response = await getChargesReport();
	// 		const response = await getVisit();
	// 		if (response?.status === 200) {
	// 			setAllVisits(response?.data);
	// 			console.log('Visits Data ==> ', response?.data);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching Visits:', error);
	// 	}
	// };

	// Patient Api function
	const getPatientData = async () => {
		// setPatientLoading(true);
		try {
			const response = await getPatientList(practiceID);
			setAllPatientsData(response?.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// Define table styles
	const styles = {
		cellPadding: 1.5,
		fontSize: 10,
		halign: 'center',
		valign: 'middle',
		// fillColor: '#EEEEEE', // Background color of table cells
		// textColor: '#000000', // Text color of table cells
		fontStyle: 'normal', // Font style of table cells
		// overflow: 'ellipsize', // How to handle overflowing content
		lineWidth: 0.1, // Width of table borders
		lineColor: '#000000', // Color of table borders
	};

	// Define header styles
	const headerStyles = {
		fillColor: '#CCCCCC', // Background color of header row
		textColor: '#000000', // Text color of header row
		fontStyle: 'bold', // Font style of header row
	};

	// Download PDF File -- Filter Data

	{
		/*	const downloadFilterPDFData = (data) => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Length of Stay History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;
		// Set the font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Length of Stay History', xPos, 15);
		// Reset the font if you need to add other non-bold text
		doc.setFont('helvetica', 'normal');
		let startY = 20; // Initial startY position

		const addPatientTitle = (title) => {
			doc.text(title, 10, startY + 10);
		};

		// const addTable = (data) => {

		doc.autoTable({
			startY: startY + 15,
			head: [
				[
					// Column Fields Name here
					'Serial No.',
					'Patient Name',
					'Sex',
					'DOB',
					// Dates
					'Admit Date',
					'Discharge Date',
					'Length of Stay',
					'Admitting Diagnoses',
				],
			],
			body: data?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ' ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'other'
							: '',
				item?.DOB != null ? dayjs(item?.DOB).format('MM-DD-YYYY') : '',
				item?.Admission_date != null
					? dayjs(item?.Admission_date).format('MM-DD-YYYY')
					: '--',
				item?.discharge_date != null
					? dayjs(item?.discharge_date).format('MM-DD-YYYY')
					: '--',
				dayjs(item?.Admission_date).isValid()
					? dayjs(item?.discharge_date).isValid()
						? dayjs(item?.discharge_date).diff(
								dayjs(item?.Admission_date),
								'day'
							)
						: dayjs().diff(dayjs(item?.Admission_date), 'day')
					: '--',
				`${item?.Dx1Description === null ? '' : item?.Dx1Description + ', '}${item?.Dx2Description === null ? '' : item?.Dx2Description + ', '} ${item?.Dx3Description === null ? '' : item?.Dx3Description + ', '} ${item?.Dx4Description === null ? '' : item?.Dx4Description + ', '} ${item?.Dx5Description === null ? '' : item?.Dx5Description + ', '} ${item?.Dx6Description === null ? '' : item?.Dx6Description + ', '} ${item?.Dx7Description === null ? '' : item?.Dx7Description + ', '} ${item?.Dx8Description === null ? '' : item?.Dx8Description + ', '} ${item?.Dx9Description === null ? '' : item?.Dx9Description + ', '} ${item?.Dx10Description === null ? '' : item?.Dx10Description + ', '} ${item?.Dx11Description === null ? '' : item?.Dx11Description + ', '} ${item?.Dx12Description === null ? '' : item?.Dx12Description + ', '} `,
			]),
			styles: styles,
			headStyles: headerStyles, // Updated to headStyles
		});
		// };

		const addNewPageIfNeeded = (spaceNeeded) => {
			if (spaceNeeded) {
				doc.addPage();
				startY = 20; // Reset startY for the new page
			}
		};

		const uniquePatients = [
			...new Set(
				data.map((item) => item?.patient?.Fname + ' ' + item?.patient?.Lname)
			),
		];

		uniquePatients.forEach((patient, index) => {
			const patientData = data.filter(
				(item) => item?.patient?.Fname + ' ' + item?.patient?.Lname === patient
			);
			const patientTitle = `Patient: ${patient}`;

			const tableSpaceNeeded = patientData.length * 10 + 40;
			const spaceNeeded =
				startY + tableSpaceNeeded > doc.internal.pageSize.getHeight() - 20;

			addNewPageIfNeeded(spaceNeeded && index > 0);

			addPatientTitle(patientTitle);
			// addTable(patientData);

			startY = doc.autoTable.previous.finalY + 5;
		});

		doc.save('Length of Stay History.pdf');
	};*/
	}
	const downloadFilterPDFData = (data) => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Length of Stay History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Set the title font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Length of Stay History', xPos, 15);

		// Reset the font for the rest of the text
		doc.setFont('helvetica', 'normal');
		let startY = 20;

		const addPatientTitle = (title) => {
			doc.text(title, 10, startY + 10);
		};

		const uniquePatients = [
			...new Set(
				data.map((item) => item?.patient?.Fname + ' ' + item?.patient?.Lname)
			),
		];

		uniquePatients.forEach((patient, index) => {
			// Start a new page for every patient after the first one
			if (index > 0) {
				doc.addPage();
				startY = 20; // Reset startY for the new page
			}

			// Add the patient's title
			const patientTitle = `Patient: ${patient}`;
			addPatientTitle(patientTitle);

			// Filter data for the specific patient
			const patientData = data.filter(
				(item) => item?.patient?.Fname + ' ' + item?.patient?.Lname === patient
			);

			// Add the table for this patient's data
			doc.autoTable({
				startY: startY + 15,
				head: [
					[
						'Serial No.',
						'Patient Name',
						'Sex',
						'DOB',
						'Admit Date',
						'Discharge Date',
						'Length of Stay',
						'Admitting Diagnoses',
					],
				],
				body: patientData?.map((item, index) => [
					index + 1,
					item?.patient?.Lname + ' ' + item?.patient?.Fname,
					item?.Gender === 'M'
						? 'Male'
						: item?.Gender === 'F'
							? 'Female'
							: 'Other',
					item?.DOB ? dayjs(item?.DOB).format('MM-DD-YYYY') : '',
					item?.Admission_date
						? dayjs(item?.Admission_date).format('MM-DD-YYYY')
						: '--',
					item?.discharge_date
						? dayjs(item?.discharge_date).format('MM-DD-YYYY')
						: '--',
					dayjs(item?.Admission_date).isValid()
						? dayjs(item?.discharge_date).isValid()
							? dayjs(item?.discharge_date).diff(
									dayjs(item?.Admission_date),
									'day'
								)
							: dayjs().diff(dayjs(item?.Admission_date), 'day')
						: '--',
					`${item?.Dx1Description || ''}, ${item?.Dx2Description || ''}, ${item?.Dx3Description || ''}`,
				]),
				styles: styles,
				headStyles: headerStyles, // Updated to headStyles
			});

			// Adjust startY for the next patient
			startY = doc.autoTable.previous.finalY + 5;
		});

		doc.save('Length of Stay History.pdf');
	};

	// Download PDF All Data
	const downloadAllDataPDF = () => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Length of Stay History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Set the Text font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Length of Stay History', xPos, 15);
		doc.setFont('helvetica', 'normal');

		const uniquePatients = [
			...new Set(
				allVisits?.map((item) => item?.patient?.Fname + item?.patient?.Lname)
			),
		];

		let currentY = 25; // Initialize Y position

		uniquePatients.forEach((patientName) => {
			// Calculate the height needed for the current patient's title and table
			const titleHeight = 10; // Rough estimate for the title height
			const tableStartY = currentY + titleHeight + 10; // Adding margin
			const rowsPerPage = Math.floor(
				(doc.internal.pageSize.height - tableStartY) / 10
			);
			const filteredVisits = allVisits?.filter(
				(item) =>
					item?.patient?.Fname + '' + item?.patient?.Lname === patientName
			);

			const tableData = filteredVisits?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ' ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'Other'
							: '',
				item?.DOB != null ? dayjs(item?.DOB).format('MM-DD-YYYY') : '--',
				item?.Admission_date != null
					? dayjs(item?.Admission_date).format('MM-DD-YYYY')
					: '--',
				item?.discharge_date != null
					? dayjs(item?.discharge_date).format('MM-DD-YYYY')
					: '--',
				dayjs(item?.Admission_date).isValid()
					? dayjs(item?.discharge_date).isValid()
						? dayjs(item?.discharge_date).diff(
								dayjs(item?.Admission_date),
								'day'
							)
						: dayjs().diff(dayjs(item?.Admission_date), 'day')
					: '--',
				`${item?.Dx1Description || ''}, ${item?.Dx2Description || ''}, ${item?.Dx3Description || ''}, ${item?.Dx4Description || ''}, ${item?.Dx5Description || ''}, ${item?.Dx6Description || ''}, ${item?.Dx7Description || ''}, ${item?.Dx8Description || ''}, ${item?.Dx9Description || ''}, ${item?.Dx10Description || ''}, ${item?.Dx11Description || ''}, ${item?.Dx12Description || ''}`,
			]);

			// Check if there is enough space on the current page for the title and at least one row of the table
			const estimatedTableHeight = tableData.length * 10; // Rough estimate for the table height (10 height per row)
			if (tableStartY + estimatedTableHeight > doc.internal.pageSize.height) {
				doc.addPage();
				currentY = 25; // Reset Y position after a new page is added
			}

			// Set the Text font to bold and add patient title
			doc.setFont('helvetica', 'bold');
			doc.text(`Patient: ${patientName}`, 14, currentY);
			doc.setFont('helvetica', 'normal');

			currentY += titleHeight; // Update Y position for the table

			var tableConfig = {
				startY: currentY,
				margin: { top: 10, right: 0, bottom: 4, left: 5 },
				tableWidth: 280,
				tableHeight: 30,
			};

			// Add the table for the current patient
			doc.autoTable({
				head: [
					[
						'Serial No.',
						'Patient Name',
						'Sex',
						'DOB',
						'Admit Date',
						'Discharge Date',
						'Length of Stay',
						'Admitting Diagnoses',
					],
				],
				body: tableData,
				styles: styles,
				headStyles: headerStyles,
				...tableConfig,
				didDrawPage: (data) => {
					currentY = data.cursor.y + 10; // Update Y position for the next title
				},
			});

			// Update the currentY to the end of the table
			currentY = doc.autoTable.previous.finalY + 10;
		});

		// Save the PDF document
		doc.save('Length of Stay History.pdf');
	};

	// Filter PDF Data
	const searchValuesFilter = () => {
		const filterationData = allVisits?.filter((item) => {
			// Check if patient matches the selected patient, if any selected
			const isPatientMatch =
				selectPatient?.length === 0 || selectPatient.includes(item?.patient_id);
			// Convert fromDate and toDate to Date objects

			const admissionDate = dateValue.admitDate
				? new Date(dateValue.admitDate)
				: null;
			const dischargeDate = dateValue.dischargeDate
				? new Date(dateValue.dischargeDate)
				: null;

			const admDate = new Date(item?.Admission_date);
			const discargeDate = new Date(item?.discharge_date);
			const isAdmissionDateMatch = !admissionDate || admDate >= admissionDate;
			const isDischargeDateMatch =
				!dischargeDate || discargeDate <= dischargeDate;

			// Return true if all conditions are met
			return isPatientMatch && isAdmissionDateMatch && isDischargeDateMatch;
		});

		downloadFilterPDFData(filterationData); // Calling Download Filter Data Function -- PDF File
		setFilterationData(filterationData);
	};

	// Function -- Download PDF Data
	const handleDownloadPdf = async () => {
		if (
			(selectPatient && selectPatient.length !== 0) ||
			dateValue.admitDate ||
			dateValue.dischargeDate
		) {
			searchValuesFilter(); // Filter Pdf
		} else {
			downloadAllDataPDF(); // All Data
		}
	};

	// Function - Download CSV File with All Data
	const downloadAllCSV = () => {
		const columns = [
			[
				// Colmn Fields Name here
				'Patient Name',
				'Sex',
				'DOB',
				// Dates
				'Admit Date',
				'Discharge Date',
				'Length of Stay',
				'Admitting Diagnoses',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming allVisits is an array of objects
		allVisits?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient?.Lname + ',' + row?.patient?.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'O' || row?.Gender == 'o'
									? 'other'
									: '',
						row?.DOB != null ? dayjs(row?.DOB).format('MM-DD-YYYY') : '--',
						row?.Admission_date != null
							? dayjs(row?.Admission_date).format('MM-DD-YYYY')
							: '--',
						row?.discharge_date != null
							? dayjs(row?.discharge_date).format('MM-DD-YYYY')
							: '--',
						dayjs(row?.Admission_date).isValid()
							? dayjs(row?.discharge_date).isValid()
								? dayjs(row?.discharge_date).diff(
										dayjs(row?.Admission_date),
										'day'
									)
								: dayjs().diff(dayjs(row?.Admission_date), 'day')
							: '--',
						`${row?.Dx1Description === null ? '' : row?.Dx1Description + ', '}${row?.Dx2Description === null ? '' : row?.Dx2Description + ', '} ${row?.Dx3Description === null ? '' : row?.Dx3Description + ', '} ${row?.Dx4Description === null ? '' : row?.Dx4Description + ', '} ${row?.Dx5Description === null ? '' : row?.Dx5Description + ', '} ${row?.Dx6Description === null ? '' : row?.Dx6Description + ', '} ${row?.Dx7Description === null ? '' : row?.Dx7Description + ', '} ${row?.Dx8Description === null ? '' : row?.Dx8Description + ', '} ${row?.Dx9Description === null ? '' : row?.Dx9Description + ', '} ${row?.Dx10Description === null ? '' : row?.Dx10Description + ', '} ${row?.Dx11Description === null ? '' : row?.Dx11Description + ', '} ${row?.Dx12Description === null ? '' : row?.Dx12Description + ', '} `,
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Length of Stay History.xlsx');
	};

	// Function - Download CSV File with Filter Data

	const downloadFilterCSVData = (data) => {
		const columns = [
			[
				// Colmn Fields Name here
				'Patient Name',
				'Sex',
				'DOB',
				// Dates
				'Admit Date',
				'Discharge Date',
				'Length of Stay',
				'Admitting Diagnoses',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming allVisits is an array of objects
		data?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient?.Lname + ',' + row?.patient?.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'O' || row?.Gender == 'o'
									? 'other'
									: '',
						row?.DOB != null ? dayjs(row?.DOB).format('MM-DD-YYYY') : '--',
						row?.Admission_date != null
							? dayjs(row?.Admission_date).format('MM-DD-YYYY')
							: '--',
						row?.discharge_date != null
							? dayjs(row?.discharge_date).format('MM-DD-YYYY')
							: '--',
						dayjs(row?.Admission_date).isValid()
							? dayjs(row?.discharge_date).isValid()
								? dayjs(row?.discharge_date).diff(
										dayjs(row?.Admission_date),
										'day'
									)
								: dayjs().diff(dayjs(row?.Admission_date), 'day')
							: '--',
						`${row?.Dx1Description === null ? '' : row?.Dx1Description + ', '}${row?.Dx2Description === null ? '' : row?.Dx2Description + ', '} ${row?.Dx3Description === null ? '' : row?.Dx3Description + ', '} ${row?.Dx4Description === null ? '' : row?.Dx4Description + ', '} ${row?.Dx5Description === null ? '' : row?.Dx5Description + ', '} ${row?.Dx6Description === null ? '' : row?.Dx6Description + ', '} ${row?.Dx7Description === null ? '' : row?.Dx7Description + ', '} ${row?.Dx8Description === null ? '' : row?.Dx8Description + ', '} ${row?.Dx9Description === null ? '' : row?.Dx9Description + ', '} ${row?.Dx10Description === null ? '' : row?.Dx10Description + ', '} ${row?.Dx11Description === null ? '' : row?.Dx11Description + ', '} ${row?.Dx12Description === null ? '' : row?.Dx12Description + ', '} `,
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Length of Stay History.xlsx');
	};

	// Filter PDF Data
	const searchValuesFilterCSV = () => {
		const filterationData = allVisits?.filter((item) => {
			// Check if patient matches the selected patient, if any selected
			const isPatientMatch =
				selectPatient?.length === 0 || selectPatient.includes(item?.patient_id);
			// Convert fromDate and toDate to Date objects

			const admissionDate = dateValue.admitDate
				? new Date(dateValue.admitDate)
				: null;
			const dischargeDate = dateValue.dischargeDate
				? new Date(dateValue.dischargeDate)
				: null;

			const admDate = new Date(item?.Admission_date);
			const discargeDate = new Date(item?.discharge_date);

			const isAdmissionDateMatch = !admissionDate || admDate >= admissionDate;
			const isDischargeDateMatch =
				!dischargeDate || discargeDate <= dischargeDate;

			// Return true if all conditions are met
			return isPatientMatch && isAdmissionDateMatch && isDischargeDateMatch;
		});

		downloadFilterCSVData(filterationData); // Calling Download Filter Data Function -- PDF File
		setFilterationData(filterationData);
	};

	useEffect(() => {
		const hasFilters =
			(selectPatient && selectPatient.length !== 0) ||
			dateValue.admitDate ||
			dateValue.dischargeDate;
		if (!hasFilters) {
			setFilterationData([]);
			return;
		}

		const filteredRows = allVisits?.filter((item) => {
			const isPatientMatch =
				selectPatient?.length === 0 || selectPatient.includes(item?.patient_id);
			const admissionDate = dateValue.admitDate
				? new Date(dateValue.admitDate)
				: null;
			const dischargeDate = dateValue.dischargeDate
				? new Date(dateValue.dischargeDate)
				: null;
			const admDate = new Date(item?.Admission_date);
			const discargeDate = new Date(item?.discharge_date);
			const isAdmissionDateMatch = !admissionDate || admDate >= admissionDate;
			const isDischargeDateMatch =
				!dischargeDate || discargeDate <= dischargeDate;

			return isPatientMatch && isAdmissionDateMatch && isDischargeDateMatch;
		});

		setFilterationData(filteredRows || []);
	}, [allVisits, selectPatient, dateValue.admitDate, dateValue.dischargeDate]);

	const lengthStayGridRows = filterationData?.map((row) => ({
		'Patient Name': `${row?.patient?.Lname || ''},${row?.patient?.Fname || ''}`,
		Sex:
			row?.Gender == 'M'
				? 'Male'
				: row?.Gender == 'F'
					? 'Female'
					: row?.Gender == 'O' || row?.Gender == 'o'
						? 'other'
						: '',
		DOB: row?.DOB != null ? dayjs(row?.DOB).format('MM-DD-YYYY') : '--',
		'Admit Date':
			row?.Admission_date != null
				? dayjs(row?.Admission_date).format('MM-DD-YYYY')
				: '--',
		'Discharge Date':
			row?.discharge_date != null
				? dayjs(row?.discharge_date).format('MM-DD-YYYY')
				: '--',
		'Length of Stay': dayjs(row?.Admission_date).isValid()
			? dayjs(row?.discharge_date).isValid()
				? dayjs(row?.discharge_date).diff(dayjs(row?.Admission_date), 'day')
				: dayjs().diff(dayjs(row?.Admission_date), 'day')
			: '--',
		'Admitting Diagnoses': `${row?.Dx1Description === null ? '' : row?.Dx1Description + ', '}${row?.Dx2Description === null ? '' : row?.Dx2Description + ', '} ${row?.Dx3Description === null ? '' : row?.Dx3Description + ', '} ${row?.Dx4Description === null ? '' : row?.Dx4Description + ', '} ${row?.Dx5Description === null ? '' : row?.Dx5Description + ', '} ${row?.Dx6Description === null ? '' : row?.Dx6Description + ', '} ${row?.Dx7Description === null ? '' : row?.Dx7Description + ', '} ${row?.Dx8Description === null ? '' : row?.Dx8Description + ', '} ${row?.Dx9Description === null ? '' : row?.Dx9Description + ', '} ${row?.Dx10Description === null ? '' : row?.Dx10Description + ', '} ${row?.Dx11Description === null ? '' : row?.Dx11Description + ', '} ${row?.Dx12Description === null ? '' : row?.Dx12Description + ', '} `,
	}));

	// Function -- Download CSV Data
	const handleDownloadCSV = () => {
		if (
			(selectPatient && selectPatient.length !== 0) ||
			dateValue.admitDate ||
			dateValue.dischargeDate
		) {
			searchValuesFilterCSV(); // Filter CSV
		} else {
			downloadAllCSV(); // All Data
		}
	};

	//shahid zaman function from chargelist
	const getVisitListData = async (data) => {
		setGridLoading(true);
		try {
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setAllVisits(response?.data);
			} else {
				// setVisitDataList([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setGridLoading(false);
		}
	};

	// get data Through Post method
	const filterData = {
		practice_id: practiceID,
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				// await getPatientLists();
				// await getVisits();
				await getVisitListData(filterData); // Call Visit Function
				await getPatientData(); // Call Patient Function

				// Check if all data arrays are not empty
				if (allVisits && allPatientsData) {
					setIsLoading(false); // Stop loader if all data is available
				}
			} catch (error) {
				console.error('Error fetching data:', error);
				setIsLoading(false); // Stop loader in case of error
			}
		};

		fetchData();
	}, [dateValue, selectPatient]);

	return currentPage ? (
		isLoading ? (
			<BrandedLoader title="Loading report" text="Preparing report data" />
		) : (
			<Paper
				elevation={1}
				sx={{
					margin: '1rem',
				}}
			>
				<Box
					sx={{
						flexGrow: 1,
					}}
				>
					<Box
						style={headerStyling}
						sx={{
							padding: {
								xl: '0.5rem',
								lg: '0.5rem',
								md: '0.5rem',
								sm: '0.5rem',
								xs: '0.3rem',
							},
						}}
					>
						<KeyboardBackspaceIcon
							sx={{
								fontSize: '1.5rem',
								color: 'black',
								bgcolor: 'white',
								borderRadius: '1rem',
								cursor: 'pointer',
								'&:hover': {
									bgcolor: 'black',
									color: 'white',
								},
							}}
							onClick={() => {
								setCurrentPage(false);
							}}
						/>
						<Typography
							style={headerSection}
							sx={{
								fontSize: {
									xl: '20px',
									lg: '20px',
									md: '20px',
									sm: '22px',
									xs: '16px',
								},
							}}
						>
							{' '}
							Length of Stay History
						</Typography>
					</Box>
					<Box
						sx={{
							m: 2,
							p: 2,
							background: '#fff',
							border: '1px solid #dbe6f5',
							borderRadius: '8px',
						}}
					>
						<Grid container spacing={2} alignItems="flex-end">
							<Grid item xl={2.4} lg={2.6} md={3.5} sm={6} xs={12}>
								<Typography sx={reportFilterLabelSx}>Patient</Typography>
								<FormControl fullWidth size="small" sx={reportFilterFieldSx}>
									<Select
										id="patient"
										multiple
										displayEmpty
										value={selectPatient}
										onChange={(event) => setSelectPatient(event.target.value)}
										renderValue={(selected) => {
											if (!selected.length) {
												return (
													<Typography
														component="span"
														sx={{
															fontSize: '13px',
															color: '#8a98ad',
															fontFamily: 'Poppins',
														}}
													>
														Select patient
													</Typography>
												);
											}

											const selectedNames = selected
												.map((id) => {
													const patientData = allPatientsData?.find(
														(item) => item?.patient_id === id
													);
													return patientData ? patientData?.Name : '';
												})
												.filter((name) => name);

											if (selectedNames.length === 1) {
												return selectedNames[0];
											}
											return `${selectedNames[0]} + ${selectedNames.length - 1} more`;
										}}
										MenuProps={reportMenuProps}
									>
										{allPatientsData?.map((item, index) => (
											<MenuItem key={index} value={item?.patient_id}>
												<Checkbox
													size="small"
													checked={selectPatient.includes(item?.patient_id)}
													sx={{
														p: 0.5,
														mr: 1,
														color: '#7c8da8',
														'&.Mui-checked': { color: '#2E68BA' },
													}}
												/>
												{item?.Name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xl={2.2} lg={2.3} md={3} sm={6} xs={12}>
								<Typography sx={reportFilterLabelSx}>Admit Date</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DatePicker
										value={dateValue.admitDate}
										name="admitDate"
										onChange={(event) => handleDateValue('admitDate', event)}
										slotProps={{
											textField: {
												size: 'small',
												fullWidth: true,
												placeholder: 'MM/DD/YYYY',
												sx: reportFilterFieldSx,
											},
										}}
									/>
								</LocalizationProvider>
							</Grid>
							<Grid item xl={2.2} lg={2.3} md={3} sm={6} xs={12}>
								<Typography sx={reportFilterLabelSx}>Discharge Date</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DatePicker
										value={dateValue.dischargeDate}
										name="dischargeDate"
										onChange={(event) =>
											handleDateValue('dischargeDate', event)
										}
										slotProps={{
											textField: {
												size: 'small',
												fullWidth: true,
												placeholder: 'MM/DD/YYYY',
												sx: reportFilterFieldSx,
											},
										}}
									/>
								</LocalizationProvider>
							</Grid>
							<Grid item xl={5.2} lg={4.8} md={12} sm={6} xs={12}>
								<Box
									sx={{
										display: 'flex',
										justifyContent: { lg: 'flex-end', xs: 'flex-start' },
										gap: 1,
										flexWrap: 'wrap',
									}}
								>
									<Button
										variant="contained"
										sx={reportResetButtonSx}
										disabled={
											!(
												selectPatient.length != 0 ||
												dateValue.admitDate ||
												dateValue.dischargeDate
											)
										}
										onClick={() => {
											resetValues();
										}}
									>
										Reset
									</Button>
									<Button
										variant="outlined"
										sx={reportExcelButtonSx}
										onClick={() => {
											handleDownloadCSV();
										}}
										startIcon={
											<Box
												component="img"
												src={xlsx}
												alt=""
												sx={{ width: 16, height: 16 }}
											/>
										}
									>
										Excel
									</Button>
									<Button
										variant="outlined"
										sx={reportPdfButtonSx}
										onClick={() => {
											handleDownloadPdf();
										}}
										startIcon={
											<Box
												component="img"
												src={pdf}
												alt=""
												sx={{ width: 16, height: 16 }}
											/>
										}
									>
										PDF
									</Button>
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Box>
				<Divider />
				<Box
					style={filterSectionStyle}
				>
					<ReportResultsGrid rows={lengthStayGridRows} loading={gridLoading} />
				</Box>

				{pdfUrl ? (
					<div style={{ marginTop: '20px' }}>
						<iframe src={pdfUrl} width="100%" height="600px" title="PDF" />
					</div>
				) : (
					''
				)}
			</Paper>
		)
	) : (
		<PatientReport />
	);
};

export default LengthStayHistory;
